import { getViewProps, LazyViews, onDocumentReady, resolveViewMount } from '../viewHandler'
import { preloadLocaleResources, resolveActiveLocale } from './i18n/preload'
import { migrateLocalStorageToIdb } from './store/migrateToIdb'

const views: LazyViews = {
  RoutesIndexView: () => import('./views/RoutesIndexView').then((m) => m.RoutesIndexView),
  RoutesExploreView: () =>
    import('./views/ExploreView/ExploreView').then((m) => m.RoutesExploreView),
  RoutesShowView: () => import('./views/RoutesShowView').then((m) => m.RoutesShowView),
  PlannerNewView: () => import('./views/PlannerNewView').then((m) => m.PlannerNewView),
  PlannerEditView: () => import('./views/PlannerEditView').then((m) => m.PlannerEditView),
  RegionShowView: () => import('./views/RegionShowView').then((m) => m.RegionShowView),
  RouteGroupShowView: () => import('./views/RouteGroupShowView').then((m) => m.RouteGroupShowView),
  ThematicMapsPolandBikeInfraView: () =>
    import('./views/ThematicMapsBikeInfraView').then((m) => m.ThematicMapsPolandBikeInfraView),
  ThematicMapsEuropeBikeInfraView: () =>
    import('./views/ThematicMapsBikeInfraView').then((m) => m.ThematicMapsEuropeBikeInfraView),
  ThematicMapsZanocujWLesieView: () =>
    import('./views/ThematicMapsZanocujWLesieView').then((m) => m.ThematicMapsZanocujWLesieView),
  DashboardIndexView: () =>
    import('./views/DashboardIndexView/DashboardIndexView').then((m) => m.DashboardIndexView),
  LikedIndexView: () =>
    import('./views/LikedIndexView/LikedIndexView').then((m) => m.LikedIndexView),
  FollowsIndexView: () =>
    import('./views/FollowsIndexView/FollowsIndexView').then((m) => m.FollowsIndexView),
  NotificationIndexView: () =>
    import('./views/NotificationIndexView/NotificationIndexView').then(
      (m) => m.NotificationIndexView,
    ),
  UserRouteShowView: () => import('./views/UserRouteShowView').then((m) => m.UserRouteShowView),
  UserActivityIndexView: () =>
    import('./views/UserActivityIndexView/UserActivityIndexView').then(
      (m) => m.UserActivityIndexView,
    ),
  UserActivityMapView: () =>
    import('./views/UserActivityMapView/UserActivityMapView').then((m) => m.UserActivityMapView),
  AdminUserActivityMapView: () =>
    import('./views/UserActivityMapView/AdminUserActivityMapView').then(
      (m) => m.AdminUserActivityMapView,
    ),
  ActivityHeatmapShowView: () =>
    import('./views/ActivityHeatmapShowView/ActivityHeatmapShowView').then(
      (m) => m.ActivityHeatmapShowView,
    ),
  UserActivityShowView: () =>
    import('./views/UserActivityShowView/UserActivityShowView').then((m) => m.UserActivityShowView),
  UserRouteIndexNewView: () =>
    import('./views/UserRouteIndexView/UserRouteIndexView').then((m) => m.UserRouteIndexView),
  UserCollectionIndexNewView: () =>
    import('./views/UserCollectionIndexView/UserCollectionIndexView').then(
      (m) => m.UserCollectionIndexView,
    ),
  UserCollectionShowView: () =>
    import('./views/UserCollectionShowView').then((m) => m.UserCollectionShowView),
  UserContributionIndexView: () =>
    import('./views/UserContributionIndexView/UserContributionIndexView').then(
      (m) => m.UserContributionIndexView,
    ),
  EmbedUserRouteView: () => import('./views/EmbedUserRouteView').then((m) => m.EmbedUserRouteView),
  EmbedCollectionView: () =>
    import('./views/EmbedCollectionView').then((m) => m.EmbedCollectionView),
  EmbedCyclingRouteView: () =>
    import('./views/EmbedCyclingRouteView').then((m) => m.EmbedCyclingRouteView),
  InviteShowView: () => import('./views/InviteShowView').then((m) => m.InviteShowView),
  RendererUserRouteView: () =>
    import('./views/RendererUserRouteView').then((m) => m.RendererUserRouteView),
  ImageExplorerIndexView: () =>
    import('./views/ImageExplorerIndexView').then((m) => m.ImageExplorerIndexView),
  ImageExplorerRouteViewUploadView: () =>
    import('./views/ImageExplorerRouteViewUploadView').then(
      (m) => m.ImageExplorerRouteViewUploadView,
    ),
  PlaceShowView: () => import('./views/PlaceShowView/PlaceShowView').then((m) => m.PlaceShowView),
  VeloFriendlyIndexView: () =>
    import('./views/VeloFriendlyIndexView').then((m) => m.VeloFriendlyIndexView),
  RouteRecorderNewView: () =>
    import('./views/RouteRecorderNewView').then((m) => m.RouteRecorderNewView),
  WahooRoutesView: () => import('./views/WahooRoutesView').then((m) => m.WahooRoutesView),
  BlogShowView: () => import('./views/BlogShowView/BlogShowView').then((m) => m.BlogShowView),
}

async function bootstrap() {
  try {
    // The view chunk fetch starts in the same tick as the idb migration and
    // locale fetch, so the extra network round-trip overlaps work we already
    // wait for. The locale must be fully loaded before the view mounts —
    // react-i18next does not re-render on late addResourceBundle.
    const [mount] = await Promise.all([
      resolveViewMount(views),
      migrateLocalStorageToIdb(),
      preloadLocaleResources(resolveActiveLocale()),
    ])

    mount?.(getViewProps())
  } catch (error) {
    console.error('[react-app] Failed to bootstrap view', error)
  }
}

onDocumentReady(() => {
  void bootstrap()
})
